import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import { SidebarProps } from "../utils/types";
const MobileSlider: React.FC<SidebarProps> = ({ open, setOpen, isMobile }) => {
  const theme = useTheme();
  return (
    <Box
      display={isMobile ? "flex" : "none"}
      position="fixed"
      onClick={() => setOpen(!open)}
      bottom="20px"
      left="20px"
      sx={{
        zIndex: 30,
        color: "#fff",
        cursor: "pointer",
        background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
        boxShadow: "0 12px 30px rgba(99, 91, 255, 0.34)",
        transition: "transform 160ms ease",
        "&:active": { transform: "scale(0.94)" },
      }}
      height="50px"
      width="50px"
      justifyContent="center"
      alignItems="center"
      borderRadius="15px"
    >
      <MenuIcon sx={{ color: "inherit" }} />
    </Box>
  );
};
export default MobileSlider;
